module.exports = __webpack_public_path__ + "static/media/Hoboken4.51d037d8.jpg";